import { render } from "./ProfilePagePart3YearsList.vue?vue&type=template&id=2f24df24"
import script from "./ProfilePagePart3YearsList.vue?vue&type=script&lang=js"
export * from "./ProfilePagePart3YearsList.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__